// src/components/sales/SalesSidebar.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import {
  Users,
  MessageSquare,
  StickyNote,
  Mail,
  CalendarClock,
  BarChart3,
} from "lucide-react";

const linkBase =
  "flex items-center gap-3 px-4 py-3 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 transition";
const active =
  "bg-gradient-to-r from-pink-500/20 to-purple-600/25 border-white/20 shadow-[0_0_18px_rgba(255,0,255,0.18)]";

export default function SalesSidebar() {
  const { t, i18n } = useTranslation();
  void i18n;

  const item = (to, label, Icon) => (
    <NavLink
      to={to}
      className={({ isActive }) => `${linkBase} ${isActive ? active : ""}`}
      end
    >
      <Icon className="w-5 h-5 text-pink-200" />
      <span className="text-sm font-semibold text-white">{label}</span>
    </NavLink>
  );

  return (
    <aside className="w-full lg:w-[290px] shrink-0">
      <div className="backdrop-blur-2xl bg-white/10 border border-white/20 rounded-2xl p-4 shadow-[0_0_35px_rgba(255,0,255,0.14)]">
        <div className="mb-4">
          <div className="text-lg font-bold text-white">{t("sales.sidebar.title")}</div>
          <div className="text-xs text-white/70">{t("sales.sidebar.subtitle")}</div>
        </div>

        <div className="flex flex-col gap-2">
          {item("/sales/clients", t("sales.sidebar.prospect"), Users)}
          {item("/sales/sales-templates", t("sales.sidebar.salesTemplates"), Mail)}
          {item("/sales/scheduled-messages", t("sales.sidebar.scheduledMessages"), CalendarClock)}
          {item("/sales/client-interactions", t("sales.sidebar.clientInteractions"), MessageSquare)}
          {item("/sales/sales-notes", t("sales.sidebar.salesNotes"), StickyNote)}
          {item("/sales/marketing-dashboard", t("sales.sidebar.marketingDashboard"), BarChart3)}
        </div>
      </div>
    </aside>
  );
}
